import React, { useEffect, useState } from "react";
import axios from "axios";
import { TextField,Typography, Button, MenuItem, Select, FormControl, InputLabel, SelectChangeEvent, Box } from "@mui/material";
import styles from "./profileForm.module.scss";
import UserImg from "../../app/images/user.png";
import EditIcon from "@mui/icons-material/Edit";


const API_BASE_URL = "https://api.drymatec.de/api/user";

const ProfileForm: React.FC = () => {
  const [formData, setFormData] = useState({
    username: "",
    firstname: "",
    lastname: "",
    eMail: "",
    image: UserImg,
    note: "",
    roles: "User",
    _id: "",
    isActive: false,
  });
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [userId, setUserId] = useState<string | null>(null);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));

        setUserId(payload.id);

      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setFormData(response.data);
        console.log("formDate", formData)
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (userId) {
      fetchUserData();
    }
  }, [userId]);


  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (e: SelectChangeEvent<string>, field: string) => {
     let { value } = e.target;

     setFormData((prevData) => ({
       ...prevData,
       [field]: field === "isActive" ? value === "true" : value,
     }));
   };

   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedImage(file);


      const reader = new FileReader();
      reader.onload = () => {
        if (reader.result) {
          setFormData((prev) => ({ ...prev, image: reader.result as string }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${API_BASE_URL}/${userId}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      console.log("User updated successfully:", response.data);
      alert("User updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Failed to update user. Please try again.");
    }
  };

  return (
    <div>
      <div className={styles.settings}>

        <form
          onSubmit={handleSubmit}
          style={{
                width: "100%",position: "relative",margin: "0 auto",display: "flex",flexDirection: "column", columnGap: "40px"}}>
       <div className={styles.avatar}>
        <img className={styles.avatarImg} src={formData.image || UserImg} alt="User avatar" />
        <label htmlFor="avatar-upload">
          <div className={styles.editIcon}><EditIcon /></div>
        </label>
        <input
          type="file"
          id="avatar-upload"
          style={{ display: "none" }}
          accept="image/*"
          onChange={handleImageChange}
        />
      </div>
          <div className={styles.innerBox}>
            <div className={styles.formWrap}>
            {/* Name */}
              <Box sx={{width:"100%"}}>
                  <label htmlFor="firstname" style={{ display: "block", marginBottom: "7px", fontSize: "14px" }}>
                    Vorname
                  </label>
                  <TextField
                    id="firstname"
                    sx={{
                      borderRadius: "23px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "1.5px solid #EBEEFA",
                          borderRadius: "23px",
                        },
                        "&:hover fieldset": {
                          borderColor: "#7688DB",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#7688DB",
                        },
                      },
                      input: {
                        color: "#7688DB",
                        fontSize: "14px",
                      },
                    }}
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                  />
              </Box>
                 {/* Surname */}
                 <Box  sx={{width:"100%"}}>
                    <label htmlFor="lastname" style={{ display: "block", marginBottom: "7px", fontSize: "14px" }}>
                    Nachname
                    </label>
                    <TextField
                      id="lastname"
                      name="lastname"
                      sx={{
                        borderRadius: "23px",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "1.5px solid #EBEEFA",
                            borderRadius: "23px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#7688DB",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#7688DB",
                          },
                        },
                        input: {
                          color: "#7688DB",
                          fontSize: "14px",
                        },
                      }}
                      placeholder="Morris"
                      value={formData.lastname}
                      onChange={handleInputChange}
                      fullWidth
                      variant="outlined"
                    />
                  </Box>

            </div>
            <div className={styles.formWrap}>
                {/* Username */}
            <Box  sx={{width:"100%"}}>
                  <label htmlFor="username" style={{ display: "block", marginBottom: "7px", fontSize: "14px" }}>
                    Username
                  </label>
                  <TextField
                    id="username"
                    name="username"
                    sx={{
                      borderRadius: "23px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "1.5px solid #EBEEFA",
                          borderRadius: "23px",
                        },
                        "&:hover fieldset": {
                          borderColor: "#7688DB",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#7688DB",
                        },
                      },
                      input: {
                        color: "#7688DB",
                        fontSize: "14px",
                      },
                    }}
                    type="text"
                    value={formData.username}
                    onChange={handleInputChange}
                    fullWidth
                    variant="outlined"
                  />
                </Box>

                  {/* Phone Number */}
                  <Box  sx={{width:"100%"}}>
                    <label htmlFor="note" style={{ display: "block", marginBottom: "7px", fontSize: "14px" }}>
                      Telefonnummer
                    </label>
                    <TextField
                      id="note"
                      name="note"
                      type="tel"
                      sx={{
                        borderRadius: "23px",
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            border: "1.5px solid #EBEEFA",
                            borderRadius: "23px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#7688DB",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#7688DB",
                          },
                        },
                        input: {
                          color: "#7688DB",
                          fontSize: "14px",
                        },
                      }}
                      placeholder="+49 30 1234 5678"
                      value={formData.note}
                      onChange={handleInputChange}
                      fullWidth
                      variant="outlined"
                    />
                  </Box>
            </div>
            <div className={styles.formWrap}>
                    {/* Role (Select) */}
                    <Box  sx={{width:"50%"}}>
                  <label htmlFor="roles" style={{ display: "block", marginBottom: "7px", fontSize: "14px" }}>
                    Role
                  </label>
                  <FormControl fullWidth>
                    <Select
                      id="roles"
                      name="roles"
                      value={formData.roles}
                      onChange={(e) => handleSelectChange(e, "roles")}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "1.5px solid #EBEEFA",
                          borderRadius: "23px",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#7688DB",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#7688DB",
                        },
                        "& .MuiSelect-select": {
                          color: "#7688DB",
                          fontSize: "14px",
                        },
                      }}
                    >
                      <MenuItem value="Admin">Admin</MenuItem>
                      <MenuItem value="User">User</MenuItem>
                      <MenuItem value="Guest">Guest</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
            </div>
             <div className={styles.btnWrap}>
             <Button className={styles.submitBtn} type="submit" variant="contained" color="primary" fullWidth>
                Speichern
                </Button>
             </div>

          </div>
    </form>
          </div>


    </div>
  );
};

export default ProfileForm;
